import * as betgalaxy from './Breadcrumb.styles.betgalaxy';
import * as betprofessor from './Breadcrumb.styles.betprofessor';
import * as betroyale from './Breadcrumb.styles.betroyale';
import * as fiestabet from './Breadcrumb.styles.fiestabet';
import * as puntcity from './Breadcrumb.styles.puntcity';
import * as puntgenie from './Breadcrumb.styles.puntgenie';
import * as questbet from './Breadcrumb.styles.questbet';
import * as sterlingparker from './Breadcrumb.styles.sterlingparker';
import * as vikingbet from './Breadcrumb.styles.vikingbet';
import * as volcanobet from './Breadcrumb.styles.volcanobet';
import * as wellbet from './Breadcrumb.styles.wellbet';
import * as juicybet from './Breadcrumb.styles.juicybet';
import * as goldenrush from './Breadcrumb.styles.goldenrush';
import * as forsport from './Breadcrumb.styles.forsport';
import * as junglebet from './Breadcrumb.styles.junglebet';
import * as oldgill from './Breadcrumb.styles.oldgill';
import * as sugarcastle from './Breadcrumb.styles.sugarcastle';
import * as buffalobet from './Breadcrumb.styles.buffalobet';
import * as titanbet from './Breadcrumb.styles.titanbet';
import * as gigabet from './Breadcrumb.styles.gigabet';
import * as slambet from './Breadcrumb.styles.slambet';
import * as betstride from './Breadcrumb.styles.betstride';
import * as templebet from './Breadcrumb.styles.templebet';
import * as goldenbet888 from './Breadcrumb.styles.goldenbet888';
import * as hyperbet from './Breadcrumb.styles.hyperbet';
import * as bet777 from './Breadcrumb.styles.bet777';
import * as chromabet from './Breadcrumb.styles.chromabet';
import * as bet575 from './Breadcrumb.styles.bet575';
import * as betblast from './Breadcrumb.styles.betblast';
import * as pyramidbet from './Breadcrumb.styles.pyramidbet';
import * as magnumbet from './Breadcrumb.styles.magnumbet';
import { themeName } from '@/helpers/getThemeConfig';

export const imports = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  juicybet,
  goldenrush,
  forsport,
  junglebet,
  oldgill,
  sugarcastle,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
} as Record<string, any>;

export const styleImports = imports[themeName];
